import { Component, inject, OnInit } from "@angular/core";
import { Store } from "@ngrx/store";
import { environment } from "src/environments/environment";
import { selectViewModel } from "./product-availability-dashboard-page.selectors";

@Component({
  selector: "app-product-availability-dashboard-page",
  templateUrl: "./product-availability-dashboard-page.component.html",
  styleUrls: ["./product-availability-dashboard-page.component.scss"],
  standalone: false,
})
export class ProductAvailabilityDashboardPageComponent implements OnInit {
  private store = inject(Store);
  vm$ = this.store.select(selectViewModel);

  public dashboardHeight: number;
  public dashboardUrl: string;

  headerHeight = 50;
  navbarHeight = 40;
  titleHeight = 30;
  marginsHeight = 40;

  ngOnInit() {
    this.dashboardUrl = `${environment.powerbiReportApi}/embedreport?reportId=${environment.productAvailabilityDashboardId}`;
    this.dashboardHeight =
      window.innerHeight -
      this.headerHeight -
      this.navbarHeight -
      this.titleHeight -
      this.marginsHeight;
  }
}
